import { z } from "zod";

export const raw16Schema = z.string().regex(/^[0-9a-f]{32}$/u);

const timestampSchema = z.string().datetime({ offset: true });

export const propertyCalendarSchema = z.strictObject({
  calendarId: raw16Schema,
  propertyId: raw16Schema,
  calendarUrl: z.string().min(8).max(1000),
  calendarSource: z.literal("AIRBNB"),
  status: z.literal("ACTIVE"),
  lastSyncedAt: timestampSchema.nullable(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const propertyCalendarGetResponseSchema = z.strictObject({
  status: z.literal("ok"),
  calendar: propertyCalendarSchema.nullable(),
});

export const propertyCalendarUpsertResponseSchema = z.strictObject({
  status: z.enum(["updated", "unchanged"]),
  calendar: propertyCalendarSchema,
});

export const propertyCalendarRevokeResponseSchema = z.strictObject({
  status: z.enum(["revoked", "unchanged"]),
});

export type PropertyCalendar = z.infer<typeof propertyCalendarSchema>;
